//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 导入模块
import vueJsonEditor from 'vue-json-editor';
export default {
  name: 'Two',
  components: { vueJsonEditor },
  // 注册组件
  props: {
    type: {
      default: 'edit',
      type: String,
    },
    show: {
      default: false,
      type: Boolean,
    },
    json: {
      type: Object,
    },
  },
  data() {
    return {
      hasJsonFlag: true, // json是否验证通过
      // json数据
      resultInfo: '',
    };
  },
  created() {
    this.resultInfo = this.json;
  },
  mounted() {},
  methods: {
    onJsonChange(value) {
      // 实时保存
      this.onJsonSave(value);
    },
    onJsonSave(value) {
      this.resultInfo = value;
      this.hasJsonFlag = true;
    },
    onError(value) {
      console.log('json格式错误:', value);
      this.hasJsonFlag = false;
    },
    // 检查json
    checkJson() {
      if (this.hasJsonFlag == false && this.type === 'edit') {
        this.$message.error('json格式错误');
        return false;
      }
      this.$emit('handleClose', this.resultInfo);
      return true;
    },
    handleClose() {
      this.$emit('handleClose');
    },
  },
};
